import {PricedItemGroupEntryChanged} from '../types/PricedItemGroupEntryChanged';

/**
 * The version that a grouped full-body update (`trim.update`, `variantMatrix.patchCell`) sends,
 * read when the group is sent. The body was made from the item at `baseVersion` when the entry was
 * added. A write to the item meanwhile (another author, another tab) fails with PricedItemGroupEntryChanged, so the body does not overwrite it.
 */
export const unchangedStoredVersion = async (
  baseVersion: number,
  readVersion: () => Promise<number>
) => {
  const version = await readVersion();
  if (version !== baseVersion) {
    throw new PricedItemGroupEntryChanged();
  }
  return version;
};
